import styled from "styled-components";
import { WrapperContainer } from "../../../components";
import { colors } from "../../../consts";

export const HardwareTableWrapper = styled(WrapperContainer)`
  table {
    tr {
      td:first-of-type {
        width: 200px;
      }
    }
  }
`;

export const HardwareIconContainer = styled(WrapperContainer)`
  background: ${colors.ISABELLINE_DARKER};
  width: 40px;
  height: 40px;
  min-width: 40px;

  border-radius: 8px;
`;

export const ButtonsWrapper = styled(WrapperContainer)`
  button {
    height: 40px;
    padding: 0 24px;
  }
`;
